import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const useAppLayout = () => {
  
  axios.defaults.withCredentials = true;

  const [menu, setMenu] = useState(false);

  const toggleMobileMenu = () => {
    setMenu(prev => !prev);
  };


  return {
    menu,
    toggleMobileMenu
  };


  /*const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [showSidebar, setShowSidebar] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
    setShowSidebar(!showSidebar);
  };

  return {
    navigate,
    isSidebarVisible,
    showSidebar,
    toggleSidebar,
  };*/
};

export default useAppLayout;